import { render } from "./InstructorDetailsArea.vue?vue&type=template&id=38c4c40c&scoped=true"
import script from "./InstructorDetailsArea.vue?vue&type=script&lang=js"
export * from "./InstructorDetailsArea.vue?vue&type=script&lang=js"

import "./InstructorDetailsArea.vue?vue&type=style&index=0&id=38c4c40c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c4c40c"]])

export default __exports__